import { sequence } from 'cerebral'

function showDialogFactory({
  title,
  content,
  type = 'alert',
  confirm,
  dismiss = null,
  checkOption = {}
}) {
  function showDialog({ state, resolve }) {
    const { params = {} } = content

    const resolver = params => {
      if (!params) {
        return {}
      }

      return Object.keys(params).reduce((acc, param) => {
        acc[param] = resolve.value(params[param])

        return acc
      }, {})
    }
    const { signal, args } = confirm
    const { checked, unchecked } = checkOption

    state.merge('app.dialog', {
      title: {
        key: resolve.value(title.key),
        params: resolver(title.params)
      },
      content: {
        key: resolve.value(content.key),
        params: resolver(params)
      },
      type: resolve.value(type),
      confirm: {
        signal: resolve.value(signal),
        args: resolver(args)
      },
      checkOption: checked
        ? {
            title: checkOption.title,
            checked: checked.signal,
            unchecked: unchecked.signal,
            value: false
          }
        : null,
      dismiss: dismiss
        ? {
            signal: dismiss.signal,
            args: resolver(dismiss.args)
          }
        : null
    })
  }
  return sequence('showDialog', [showDialog])
}

export default showDialogFactory



// WEBPACK FOOTER //
// ./src/modules/App/factories/showDialog.js